<template>
  <v-hover v-slot="{ hover }">
    <v-card
      :elevation="hover ? 12 : 5"
      :class="{ 'scale-up': hover }"
      class="course-card mx-auto rounded-xl transition-all duration-300 overflow-hidden"
      @click="goToCourse(item)"
    >
      <div class="relative overflow-hidden">
        <v-img
          :src="
            item.thumb ?? 'https://cdn.vuetifyjs.com/images/cards/desert.jpg'
          "
          height="200px"
          class="course-image"
          style="object-fit: cover"
        >
          <div
            class="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"
          ></div>
        </v-img>
      </div>

      <v-card-title class="pb-2">
        <h3 class="text-h6 font-weight-bold text-truncate transition-colors">
          {{ item.title }}
        </h3>
      </v-card-title>

      <v-card-text class="pt-0">
        <div
          class="d-flex align-center justify-space-between pt-1 border-t border-slate-100"
        >
          <div class="d-flex align-center gap-1 text-color-slate-500">
            <v-rating
              color="amber"
              background-color="orange lighten-3"
              :length="5"
              :value="item.rating"
              size="18"
            ></v-rating>
          </div>

          <div class="d-flex align-center gap-1 text-color-slate-500">
            <v-icon small>mdi-clock-outline</v-icon>
            <span class="text-sm font-weight-medium">{{
              item.estimatedTime ?? "0h"
            }}</span>
          </div>
        </div>

        <v-row dense class="mt-4">
          <v-col cols="12">
            <v-btn
              :color="moduleColor"
              dark
              block
              rounded
              class="font-weight-medium"
              @click.stop="goToCourse(item)"
              elevation="0"
            >
              Acessar {{ moduleText }}
              <v-icon right small>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-divider class="mt-4 mb-2"></v-divider>

        <v-row class="mt-2">
          <v-col class="d-flex align-center justify-start pb-4" cols="12">
            <v-icon small color="grey darken-1">mdi-file-outline</v-icon>
            <span class="grey--text ml-2 text-sm font-weight-medium"
              >{{ item.totalLesons }} Aulas</span
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: "CourseCard",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    moduleColor: {
      type: String,
      default: "aluno",
    },
    moduleText: {
      type: String,
      default: "Aula",
    },
  },
  // Removido o localItem, pois não é necessário aqui
  // mounted() {
  //   if (this.item) this.localItem = this.item;
  // },
  // data() {
  //   return {
  //     localItem: {},
  //   };
  // },
  methods: {
    goToCourse(item) {
      this.$emit("toCourse", item);
    },
  },
};
</script>

<style scoped>
/* Estilos CSS do layout moderno */
.course-card {
  transition: transform 0.3s, box-shadow 0.5s;
  cursor: pointer;
}

.course-card.scale-up {
  /* Leve elevação no hover */
  transform: translateY(-4px);
}

.course-image {
  transition: transform 0.7s;
}

.course-card:hover .course-image {
  /* Efeito de zoom na imagem no hover */
  transform: scale(1.1);
}

/* Para cores que o Vuetify não define diretamente (simulando Tailwind slate) */
.text-color-slate-500 {
  color: #64748b;
}
.border-slate-100 {
  border-color: #f1f5f9;
}

/* Utilitários Flex (gap-1) */
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}

/* Degradê adaptado do Tailwind */
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-black\/20 {
  --tw-gradient-from: rgba(0, 0, 0, 0.2);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-transparent {
  --tw-gradient-to: transparent;
}
</style>
